
import React, { Component } from "react";
import Config from "../../config";
import moment from "moment";
import {  Link, } from "react-router-dom";
import {objSearch,Default_Report_Year} from "../../utils/func";
import Card from "components/Card/Card.jsx";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
export default class BLOCK7 extends Component {
    constructor(props) {
    super(props);
    this.state = { data :[] , year : Default_Report_Year() ,sYear:2555 };
        if(!this.props.pltbldid){
            this.getData()
        }
    }




    getData(){
    let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport?token=${token}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000){
                    this.setState({data:data.data})
                }
                console.log("getData",data);
            }, err => {
            console.log("getData", err);
            });
        }

    render() {
        let {year ,data, sYear} = this.state
        let tdArray = data.map(d => {
                return [d.TSIC_ID,d.PLT_BLD_NAME,<div>


                    <Link to={{ pathname: "/xpage6", search: objSearch(
                                {
                                plt_bld_id: d.PLT_BLD_ID,
                                year: sYear,
                                time: d.TIME
                                }
                            ) }} >
                            <Button bsStyle="" pullRight fill >
                                <img src="images/iCheckList.png" />
                                            &nbsp;การตรวจสอบฯ
                            </Button>
                        </Link>
                    </div>]
            })

        let thArray = ["TSIC-ID", "ชื่อโรงงานควบคุม/อาคารควบคุม", ""]
        return <Card title={<div>รายงานการจัดการพลังงานประจำปี {year} ที่โรงงาน/อาคารอนุญาตให้กรอกข้อมูลสรุปผลการตรวจสอบได้</div>} 
            ctTableFullWidth
            ctTableResponsive
            content={<div className="legend">
            <Table striped hover>
                    <thead>
                      <tr >
                        {thArray.map((prop, key) => {
                          return <th key={key} style={{textAlign:'center'}}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {tdArray.map((prop, key) => {
                        return (
                          <tr key={key}>
                            {prop.map((prop, key) => {
                              return <td key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
            </div>} > 
           
            {/* <CardHeader color="warning" style={{ background: "#787878", boxShadow: "0 12px 20px -10px rgba(69,69,69, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(69,69,69, 0.2)" }}>
              <h4 className={"Dashboard-cardTitleWhite-851"} style={{ fontSize: "20px" }}>
                รายงานการจัดการพลังงานประจำปี {year} ที่โรงงาน/อาคารอนุญาตให้กรอกข้อมูลสรุปผลการตรวจสอบได้
              </h4>
            </CardHeader>
            <CardBody>
              {!this.props.pltbldid ? <div>
                   <Table
                        tableHeaderColor="warning"
                        tableHead={["TSIC-ID", "ชื่อโรงงานควบคุม/อาคารควบคุม", ""]}
                        tableData={table}
                        />
                </div> : <div>
                  <div id="menu-title" style={{ backgroundImage: "url(images/SilverBar.png)", color: "dblue", fontSize: "23px" }}>
                    รายงานการจัดการพลังงานประจำปี
                  </div>
                </div>}
            </CardBody> */}
          </Card>;
    }
}




// WEBPACK FOOTER //
// ./src/view/block/block-7.js